import configuration from "../utilities/configuration";

export const ROLES = {
    user: configuration.wdsUser,
    shopViewer: configuration.wdsShopViewerUser,
    shopManager: configuration.wdsShopManagerUser,
    admin: configuration.wdsAdminUser,
    eurex: configuration.wdsEurexUser,
    sales: configuration.wdsSalesUser
};
